import { Component, OnInit, AfterViewInit, OnDestroy, ElementRef, Renderer2, HostListener, Inject } from '@angular/core';

import { ComponenRegistryService } from '../service/component-registry.service';
import { BackdropService } from '../service/backdrop.service';

@Component({
    selector: 'app-header-nav',
    templateUrl: './headernav.component.html',
    styleUrls: ['./headernav.component.css']
})
export class HeadernavComponent implements OnInit, AfterViewInit, OnDestroy {

    _HeadernavDrawerMode: boolean = false;
    _HeadernavAlwaysDrawerMode: boolean = false;
    _folded: boolean = false;
    opened: boolean;

    constructor(
        private _el: ElementRef,
        private renderer: Renderer2,
        private _backdropService: BackdropService,
        private _componenRegistryService: ComponenRegistryService,
    ) { }

    ngOnInit() 
    {
        // Register the component in registry
        this._componenRegistryService.register('headernav', this);

        this._backdropService.close.subscribe(() => {
            if(this._HeadernavDrawerMode && this.opened) {
                this._hideHeadernav();
            }
        });

        this.toggleDrawerHeadernavMode();
    }

    ngOnDestroy() {
        this.hide();
    }

    ngAfterViewInit() {}

    headernavToggleHandler() {
        if(this._HeadernavDrawerMode) {
            this.toggleDrawerHeadernav();
        } else {
            document.body.classList.toggle('header-nav-hidden');
        }
    }


    toggleDrawerHeadernav() {
        if( this.opened ) 
        {
            this.hide();
        } 
        else 
        {
            this.show();
        }
    }

    show() {
        if( !this._HeadernavDrawerMode ) return;

        this._backdropService.show();
        this._showHeadernav();
    }

    hide() {
        if( !this._HeadernavDrawerMode ) return;

        this._backdropService.hide();
        //this._hideHeadernav();
    }

    _showHeadernav() {
        this.opened = true;

        this.renderer.addClass(this._el.nativeElement, 'shined');
        document.getElementById('header-nav').classList.add('shined');
    }

    _hideHeadernav() {
        if( this.opened ) {
            this.opened = false;

            this.renderer.removeClass(this._el.nativeElement, 'shined');
            document.getElementById('header-nav').classList.remove('shined');
        }
    }


    toggleDrawerHeadernavMode() 
    {
        if( this._HeadernavAlwaysDrawerMode ) {
            return;
        }

        if (this._canSetDrawerMode() && !this._HeadernavDrawerMode) 
        {
            this._setDrawerHeadernavMode();
        }
        else if( !this._canSetDrawerMode() && this._HeadernavDrawerMode) 
        {
            this._removeDrawerHeadernavMode();
        }
    }

    _setDrawerHeadernavMode() 
    {
        document.body.classList.add('drawer-menu');
        this._HeadernavDrawerMode = true;
    }

    _removeDrawerHeadernavMode() 
    {
        document.body.classList.remove('drawer-menu');
        this._HeadernavDrawerMode = false;
    }

    _canSetDrawerMode() 
    {
        return (window.innerWidth < 992 && !document.body.classList.contains('mini-headernav'));
    }

    @HostListener('window:resize')
    onResize() {
        this.toggleDrawerHeadernavMode();
    }

}
